package com.anjuros.website.templates.template10.modules

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalUiMode
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.templates.selection.util.Constants.placeholderPrimaryColor
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba

/** "Ink & Paper" palette. */
enum class Template10Theme(
    val hex: String,
    val rgb: CSSColorValue
) {
    Primary(hex = "#B8321F", rgb = rgb(184, 50, 31)),        // vermilion seal
    Coral(hex = "#E8846F", rgb = rgb(232, 132, 111)),        // accent on dark
    DeepRed(hex = "#8A2414", rgb = rgb(138, 36, 20)),        // eyebrow on paper
    Ink(hex = "#1C1B19", rgb = rgb(28, 27, 25)),
    InkDeep(hex = "#161513", rgb = rgb(22, 21, 19)),
    InkFooter(hex = "#121110", rgb = rgb(18, 17, 16)),
    InkCard(hex = "#34312C", rgb = rgb(52, 49, 44)),
    InkLine(hex = "#3A3731", rgb = rgb(58, 55, 49)),
    InkBorder(hex = "#4A463F", rgb = rgb(74, 70, 63)),
    InkWatermark(hex = "#26241F", rgb = rgb(38, 36, 31)),
    Paper(hex = "#F4F1EA", rgb = rgb(244, 241, 234)),
    PaperLight(hex = "#FBF9F4", rgb = rgb(251, 249, 244)),
    PaperDark(hex = "#EBE6DB", rgb = rgb(235, 230, 219)),
    Line(hex = "#D9D3C7", rgb = rgb(217, 211, 199)),
    LineSoft(hex = "#E3DDD1", rgb = rgb(227, 221, 209)),
    Muted(hex = "#57534C", rgb = rgb(87, 83, 76)),
    Stone(hex = "#B5AEA1", rgb = rgb(181, 174, 161)),
    StoneLight(hex = "#C9C3B7", rgb = rgb(201, 195, 183)),
    HeroOverlay(hex = "#161513B3", rgb = rgba(22, 21, 19, 0.72)),
    StripOverlay(hex = "#16151399", rgb = rgba(22, 21, 19, 0.6)),
    PaperLine(hex = "#F4F1EA38", rgb = rgba(244, 241, 234, 0.22)),
}

@Composable
fun Template10Theme.getColor(): CSSColorValue {
    return if (LocalUiMode.current == UiMode.NORMAL)
        this.rgb
    else
        placeholderPrimaryColor.rgb
}

@Composable
fun Template10Theme.getColorHex(): String {
    return if (LocalUiMode.current == UiMode.NORMAL)
        this.hex
    else
        placeholderPrimaryColor.hex
}
